// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({"1367": "ModelViewer","2257": "EthereumWallet","582": "NftSecondaryMarketModal","7530": "ActionToast","7581": "NftPdpZoomModal","8692": "RecentlyViewed",}[chunkId] || chunkId) + ".549.0.0." + {"1367": "f819d5a2c4bfd46b","2257": "da066017181591fc","2973": "eb72841c5680f189","582": "5a21720d8592c861","7530": "e3a5823259e38abf","7581": "860387c30226ed34","8692": "3d862bdf84d690e1",}[chunkId] + ".css"
}